import React from 'react';

import { Container } from './styles';

interface Props {
	meetup: IRepoGithub
}

const Meetup: React.FC<Props> = ({meetup}) => {
  return (
    <Container>
      <h3>{meetup.name}</h3>
      <p>{meetup.description}</p>

      <a href={meetup.html_url} rel="_new">Ver mais</a>
    </Container>
  );
}

export default Meetup;
